<template>
  <div class="claimcashback-form clearfix">
    <form id="" enctype="multipart/form-data" class="claim-form" v-if="!successMessageVisible">
      <h4>Manglende Cashback</h4>
      <div class="claimcashback-guide">
        Såfremt du imod forventning ikke har modtaget cashback for dit køb med dit tilmeldte betalingskort, kan du oprette en sag her. <br />
        <div class="info-bullets">
          Bemærk:
          <ul>
            <li>Dit betalingskort skal have været tilmeldt programmet inden dit køb hos partneren.</li>
            <li>Der skal være gået mindst 3 dage fra dit køb til du kan oprette en sag.</li>
            <li>Har du handlet hos en deltagende webshop, skal du være opmærksom på, webshoppen først trækker beløbet fra dit kort, når de afsender din bestilte vare.</li>
          </ul>
        </div>
      </div>

      <div class="clearfix form-content">
        <div class="search-price">
          <div :class="{error: !validation.location.isValid}" class="select-wrapper">
            <label>Hvor har du handlet?</label>
            <v-select v-model="selectedLocation" label="name" :options="items" @search="searchLocation" :searchable="true" :clearOnSelect="true" :key="'uuid'" class="claim-select" placeholder="Søg efter en forretning her">
              <template slot="no-options"> Søg efter en forretning </template>
              <template slot="option" slot-scope="option">
                <div class="selected d-center">{{ option.name }} - {{ option.type | type }}</div>
              </template>
            </v-select>
            <small v-if="!validation.location.isValid" class="error">{{ validation.location.message }}</small>
          </div>

          <div :class="{error: !validation.price.isValid}" class="price-wrapper">
            <label>Købspris i DKK</label>
            <input type="number" v-on:change="priceValidation" v-model="price" placeholder="Købspris i DKK" />
            <small v-if="!validation.price.isValid" class="error">{{ validation.price.message }}</small>
          </div>
        </div>

        <div class="date-card">
          <div :class="{error: !validation.date.isValid}" class="date-wrapper">
            <label>Vælg dato for købet</label>
            <div :class="{pick_date: classpick, focus_date: classFocus, bd_user_page: value}" class="datepicker-container">
              <input-date-picker v-model="date" :value="value" @input="dateValidation" v-on:pick="pick" v-on:clear="clear" v-on:focus="focus" v-on:blur="blur" valueType="YYYY-MM-DD" format="DD/MM/YYYY" placeholder="Vælg dato" />
            </div>
            <small v-if="!validation.date.isValid" class="error">{{ validation.date.message }}</small>
          </div>

          <div :class="{error: !validation.selectedCard.isValid}" class="card-select">
            <label>Venligst vælg kortet som købet omhandler</label>

            <select v-model="selectedCard">
              <option :value="null">Vælg et kort</option>
              <option v-for="(card, index) in paymentCards.items.filter((item) => item.type.toLowerCase() === 'visa')" :value="card.id" :key="index" data-index="0">
                <span class="card-name">{{ card.type }}</span>
                <span class="card-number"> - {{ card.lastFour }}</span>
              </option>
            </select>
            <small v-if="!validation.file.isValid" class="error">{{ validation.selectedCard.message }}</small>
          </div>
        </div>

        <div :class="{error: !validation.file.isValid}">
          <label>Upload dokumentation</label>
          Dokumentation for dit køb kan være din kvittering for købet, ordrebekræftelse eller kontoudtog. Du kan uploade i disse formater: jpg, png, pdf, excel eller word dokument

          <div class="fileuploads">
            <label class="custom-file-upload" v-bind:for="fileInputId">
              <span class="upload-logo"></span>
              Klik for at uploade
              <span v-if="fileName" class="file-name">{{ fileName }}</span>
            </label>
            <input type="file" class="inputfile" name="inputfile" v-bind:id="fileInputId" v-on:change="uploadFile" accept=".jpg, .jpeg, .png, .pdf, .xls, .doc, .docx" ref="fileInput" style="display: none" />
          </div>
          <small v-if="!validation.file.isValid" class="error">{{ validation.file.message }}</small>
        </div>

        <div>
          <label>Kommentar (Valgfrit)</label>

          <input type="text" v-model="text" placeholder="Kommentar (Valgfrit)" />
        </div>
        <div class="btn-box">
          <button type="submit" class="submit" :disabled="loadbutton" @click.prevent="submitForm">
            <template v-if="loadbutton">Sender...</template>
            <template v-else>Indsend</template>
          </button>
          <div v-if="errorMessage != ''" class="error-message">{{ errorMessage }}</div>
        </div>
      </div>
    </form>
    <div v-if="successMessageVisible">
      <p style="padding: 25px font-size: 20px; text-align: center;">
        Tak for indsendte <br />
        Vi bestræber os på at behandle sagen indenfor 48 timer på hverdage
      </p>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'

import {VueSelect} from 'vue-select'
import _debounce from 'lodash/debounce'
import User from 'cashback-api-js/Resources/User'

export default {
  name: 'ClaimCashback',

  props: {
    title: {
      type: String,
      default: 'Mine oplysninger',
    },
    signupFlow: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
  },

  data() {
    return {
      errorMessage: '',
      successMessageVisible: false,
      message: '',
      loading: false,
      loadbutton: false,
      user: new User(),
      paymentCards: {
        total: 0,
        items: [],
      },
      selectedCard: null,
      type: [],
      selectedLocation: null,
      items: [],
      date: null,
      price: '',
      text: '',
      fileInputId: 'fileinput',
      file: null,
      fileName: null,
      validation: {
        location: {
          isValid: true,
          message: 'Vælg venligst en lokation',
        },
        date: {
          isValid: true,
          message: 'Vælg venligst en dato',
        },
        price: {
          isValid: true,
          message: 'Indtast venligst en købspris',
        },
        file: {
          isValid: true,
          message: 'Venligst opload en kvittering',
        },
        selectedCard: {
          isValid: true,
          message: 'Venligst vælg et kort',
        },
      },
      classFocus: false,
      classpick: false,
    }
  },
  components: {
    'v-select': VueSelect,
    'input-date-picker': DatePicker,
  },
  mounted() {
    this.getPaymentCards()
    this.getUser()
    this.loading = false
  },

  filters: {
    type: function (type) {
      if (type == 'merchant') {
        return 'Butik'
      } else if (type == 'webshop') {
        return 'Webshop'
      }
    },
  },

  methods: {
    clear: function (event) {
      this.classpick = false
    },
    focus: function (event) {
      this.classFocus = true
    },
    blur: function (event) {
      this.classFocus = false
    },
    pick: function (event) {
      this.classpick = true
    },
    resetForm() {
      this.selectedLocation = null
      this.date = ''
      this.price = ''
      this.file = ''
      this.selectedCard = null
      this.formSubmitted = false
      this.text = ''
    },
    dateValidation(value) {
      if (!value) {
        this.validation.date.isValid = false
        this.validation.date.message = 'Vælg venligst en dato'
      } else {
        // Check if the value is a valid date
        let isValidDate = false
        try {
          let parsedDate = new Date(value)
          if (!isNaN(parsedDate.getTime())) {
            isValidDate = true
          }
        } catch (e) {}
        this.validation.date.isValid = isValidDate
        this.validation.date.message = isValidDate ? '' : 'Ikke en gyldig dato'
      }
    },
    priceValidation() {
      const price = this.price
      const regex = /^\d+(,\d{1,2})?$/
      if (!price) {
        this.validation.price.isValid = false
        this.validation.price.message = 'Prisen skal udfyldes'
      } else if (!regex.test(price)) {
        this.validation.price.isValid = false
        this.validation.price.message = 'Prisen skal være i form af et tal (f.eks. "10" eller "10.00")'
      } else {
        this.validation.price.isValid = true
        this.validation.price.message = ''
      }
    },
    uploadFile() {
      let input = this.$refs.fileInput
      let file = input.files[0]
      let allowedTypes = ['image/jpeg', 'image/png', 'application/pdf', 'application/vnd.ms-excel', 'application/msword']
      let maxSize = 5 * 1024 * 1024

      if (file.size > maxSize) {
        this.validation.file.isValid = false
        this.validation.file.message = 'Filen er større end 5MB, venligst opload en mindre fil'
        input.value = ''
        this.fileName = null
        this.file = null
      } else if (allowedTypes.indexOf(file.type) === -1) {
        this.validation.file.isValid = false
        this.validation.file.message = 'Forkert filtype, venligst opload i enten jpg, png, pdf, excel eller word dokument'
        input.value = ''
        this.fileName = null
        this.file = null
      } else {
        this.validation.file.isValid = true
        this.file = file
        this.fileName = file.name
      }
    },
    getUser() {
      this.$cashback
        .user()
        .then((user) => {
          this.user = user
          this.$emit('loaded')
          this.loading = false
        })
        .catch((error) => {})
    },
    searchLocation: async function (search) {
      try {
        // if (search.length < 2) {
        //   this.items = []

        //   return
        // }
        const response = await fetch(cashbackUser.locationApi + `/?filter[s]=${search}&fields[locations]=uuid,name,type&page[size]=100`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        const body = await response.json()
        this.items = body.data
      } catch (err) {
        console.error(err)
      }
    },

    getPaymentCards() {
      this.$cashback.paymentCards().then((cards) => {
        this.paymentCards = cards
        this.$emit('loaded')
        this.loading = false
      })
    },

    submitForm() {
      const validations = [
        {key: 'location', value: this.selectedLocation},
        {key: 'price', value: this.price},
        {key: 'file', value: this.file},
        {key: 'selectedCard', value: this.selectedCard},
        {key: 'date', value: this.date},
      ]

      if (validations.every(({value}) => !!value)) {
        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('user_external_id', this.user.id)
        formData.append('comment', this.text)
        formData.append('location_uuid', this.selectedLocation.uuid)
        formData.append('price', this.price)
        formData.append('purchase_date', this.date)
        formData.append('payment_card_external_id', this.selectedCard)
        this.loadbutton = true

        fetch('https://cashback-api.loyaltykey.com/api/v2/subscriber/cashback-claim', {
          method: 'POST',
          body: formData,
          headers: {
            publisher: cashbackUser.publisher,
          },
        })
          .then((response) => {
            if (response.ok) {
              // response.ok is true if status is 200-299.
              return response.json()
            } else {
              // If the response is not ok, throw an error with the status text
              throw new Error(`Request failed with status ${response.status} ${response.statusText}`)
            }
          })
          .then((data) => {
            this.loadbutton = false
            this.formSubmitted = true
            this.resetForm()
            this.successMessageVisible = true
            this.message = data.message
          })
          .catch((error) => {
            this.loadbutton = false
            // Updated error message as requested
            this.errorMessage = 'Der skete en fejl, venligst kontakt kundeservice'
          })
      } else {
        validations.forEach(({key, value}) => {
          this.validation[key].isValid = !!value
        })
      }
    },
  },
}
</script>

<style>
.vs__open-indicator {
  margin-right: 11px;
}
.vs__search,
.vs__search:focus {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  background: none !important;
  border: 1px solid transparent !important;
  border-left: none !important;
  box-shadow: none !important;
  color: var(--vs-search-input-color) !important;
  flex-grow: 1 !important;
  font-size: var(--vs-font-size) !important;
  line-height: var(--vs-line-height) !important;
  margin: 4px 0 0 !important;
  max-width: 100% !important;
  outline: none !important;
  padding: 0 7px !important;
  width: 0 !important;
  z-index: 1 !important;
}

.vs__search {
  height: 50px;
  appearance: none;
  border-radius: 10px;
  margin: 0;
  padding: 20px 16px 18px;
}
.vs__clear,
.vs__clear:hover {
  background: unset !important;
  border: unset !important;
}
.claimcashback-form input,
.claimcashback-form select {
  height: 50px !important;
  padding: 10px !important;
  line-height: 1.2;
}
.claimcashback-form {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}
.date-card {
  display: flex;
  justify-content: space-between;
}
.card-select {
  width: 60%;
}
.claimcashback-guide {
  font-size: 16px;
  line-height: 1.3;
}
.claimcashback-form .submit {
  padding: 10px 15px !important;
}
.claimcashback-form h4 {
  font-size: 1.3em;
  margin-bottom: 25px;
}
.claimcashback-form ul {
  list-style: disc;
}
.file-input {
  height: unset !important;
  left: unset !important;
  opacity: unset !important;
  outline: unset !important;
  position: unset !important;
  top: unset !important;
  width: unset !important;
}
.fileuploads {
  background: #f8f9fd;
  height: 100px;
  margin: 10px 0;
  border-radius: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  position: relative;
}
.custom-file-upload {
  display: flex !important;
  justify-content: center;
  align-items: center;
  background-color: unset !important;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.claimcashback-form .file-input,
.claimcashback-form label {
  display: block;
}
.claimcashback-form form label:not(.file-input, .custom-file-upload) {
  display: block !important;
  margin-top: 20px !important;
  font-family: var(--global--font-primary) !important;
  color: #606060 !important;
  /* text-transform: uppercase !important; */
  font-weight: bold !important;
  font-size: 15px !important;
}
.claimcashback-form textarea {
  width: 100%;
  min-height: 70px;
  border: 1px solid var(--global--color-gray-3);
  font-size: var(--global--font-size-base);
  border-radius: 6px;
}
.claimcashback-form .image-upload {
  margin-top: 10px;
}
@media only screen and (max-width: 765px) {
  .date-card {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .card-select {
    width: 100%;
  }
  .claimcashback-form {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
}
.vs__clear{
  margin: 0 !important;
  width: auto !important;
  padding: 0 10px !important;
}
.cashback-app small.error{
  font-size: 15px;
  margin-top: 5px;
}
</style>

